// extracted by mini-css-extract-plugin
export default {"timer":"style_timer__Shd7R","green":"style_green__cpKnh","orange":"style_orange__CSQgL","red":"style_red__c74c-","expired":"style_expired__M90Cp"};